<script>
  import {faMoneyBillAlt, faEnvelope, faEdit, faFilePdf} from '@fortawesome/free-regular-svg-icons'
  import ListView from '../base/ListView.vue'

  import { mapGetters } from 'vuex'
  import FilterLookupSelect from '../base/FilterLookupSelect.vue'

  export default {
    components: {
      ListView,
      FilterLookupSelect
    },
    data () {
      return {
        iconTogglePaid: faMoneyBillAlt,
        iconIssueDate: faEdit,
        iconMailDate: faEnvelope,
        iconIncomingDate: faMoneyBillAlt,
        iconPrintPdf: faFilePdf,
        error: null,
      }
    },
    computed: {
      paid () {
        return this.$store.getters['invoice/list/filter']['incomingDate[null]'] === 'ignore'
      },
      ...mapGetters({
        customer: 'invoice/list/references/customer/item',
      })
    },
    methods: {
      togglePaid () {
        this.$store.dispatch('invoice/list/setFilter', {'incomingDate[null]': this.paid ?  'true' : 'ignore'})
      },
      printPdf (invoice) {
        this.$store.dispatch('api/download', {uri: invoice.blob, defaultFilename: 'invoice.pdf'})
          .then(() => {
            this.error = null
          })
          .catch(error => {
            this.error = error
          })
      },
      renderPdf (invoice) {
        this.$store.dispatch('api/trigger', {uri: '/api/v2/invoices/' + invoice.uuid + '/renderpdf'})
          .then(() => {
            this.error = null
          })
          .catch(error => {
            this.error = error
          })
      }
    }
  }
</script>
<template>
  <list-view store="invoice" add-route="InvoiceCreate" edit-route="InvoiceUpdate">
    <template v-slot:filter="">
      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <b-button
            :pressed="paid"
            :variant="(paid ? 'danger' : 'primary')"
            @click="togglePaid"
            :title="$t(paid ? 'invoice.filter-header.paid-hide' : 'invoice.filter-header.paid-show')"
          >
            <font-awesome-icon :icon="iconTogglePaid" size="lg" />
            <span class="sr-only">&nbsp;{{$t(paid ? 'invoice.filter-header.paid-hide' : 'invoice.filter-header.paid-show')}}</span>
          </b-button>
        </b-input-group>
      </b-form-group>

      <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
        <b-input-group>
          <filter-lookup-select
            store="invoice/list/lookup/customer"
            :placeholder="$t('invoice.filter-header.customer-placeholder')"
            :search-placeholder="$t('invoice.filter-header.customer-search-placeholder')"
          >
            <template v-slot:selected-item="slotProps">
              {{slotProps.item.addr1}}
              {{slotProps.item.addr2}}
            </template>
            <template v-slot:item="slotProps">
              {{slotProps.item.addr1}}<br/>
              {{slotProps.item.addr2}}
            </template>
          </filter-lookup-select>
        </b-input-group>
      </b-form-group>
    </template>

    <template v-slot:header="slotProps">
      <b-alert v-if="error" show variant="danger" class="col-12">{{ error }}</b-alert>
      <b-col md="1"><strong>Invoice no.</strong></b-col>
      <b-col md="2"><strong>{{ $t('invoice.dates.label') }}</strong></b-col>
      <b-col md="3"><strong>{{ $t('invoice.customer.address') }}</strong></b-col>
      <b-col md="1"><strong>{{ $t('invoice.customer.customerNr') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('invoice.totalNetto.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('invoice.totalBrutto.label') }}</strong></b-col>
      <b-col md="1" class="text-right"><strong>{{ $t('invoice.taxAmount.label') }}</strong></b-col>
    </template>

    <template v-slot:item="slotProps">
      <b-col md="1">{{slotProps.item.invoiceNr}}</b-col>
      <b-col md="2">
        <div v-if="slotProps.item.issueDate">
          <font-awesome-icon :icon="iconIssueDate" />
          {{slotProps.item.issueDate|formatDate}}
        </div>
        <div v-if="slotProps.item.mailDate">
          <font-awesome-icon :icon="iconMailDate" />
          {{slotProps.item.mailDate|formatDate}}
        </div>
        <div v-if="slotProps.item.incomingDate">
          <font-awesome-icon :icon="iconIncomingDate" />
          {{slotProps.item.incomingDate|formatDate}}
        </div>
      </b-col>
      <b-col md="3">
        <span class="address1" v-if="slotProps.item.customerAddr1">{{slotProps.item.customerAddr1}}<br/></span>
        <span class="address2" v-if="slotProps.item.customerAddr2">{{slotProps.item.customerAddr2}}<br/></span>
        <span class="address3" v-if="slotProps.item.customerAddr3">{{slotProps.item.customerAddr3}}<br/></span>
        <span class="address4" v-if="slotProps.item.customerAddr4">{{slotProps.item.customerAddr4}}</span>
      </b-col>
      <b-col md="1">{{slotProps.item.customerNr}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.totalNetto|formatMoney}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.totalBrutto|formatMoney}}</b-col>
      <b-col md="1" class="text-right">{{slotProps.item.taxAmount|formatMoney}}</b-col>
    </template>

    <template v-slot:buttons="slotProps">
      <b-button
        type="button"
        title="Download PDF"
        @click="printPdf(slotProps.item)"
        :disabled="!slotProps.item.blob"
      >
        <font-awesome-icon :icon="iconPrintPdf" />
      </b-button>
      <b-button
        type="button"
        title="Render PDF"
        @click="renderPdf(slotProps.item)"
        variant="danger"
        :disabled="!!slotProps.item.mailDate"
      >
        <font-awesome-icon :icon="iconPrintPdf" />
      </b-button>
    </template>
  </list-view>
</template>

